const upsRegex = /^1Z/gi
const yrcRegex = /^\d{3}-\d{6}-\d{1}$/gm //  (always three-six-one integers)
const fedExRegex = /\b\d{12}\b/g // (always 12 digits)
const dhlRegex = /\b\d{10}\b/g // (always 10 digits)

export default function(trackingId) {
    if (upsRegex.test(trackingId)) {
        return `https://www.ups.com/track?loc=en_US&tracknum=${trackingId}`
    } else if (fedExRegex.test(trackingId)) {
        return `https://www.fedex.com/apps/fedextrack/?tracknumbers=${trackingId}`
    } else if (dhlRegex.test(trackingId)) {
        return `https://www.dhl.com/en/express/tracking.html?AWB=${trackingId}&brand=DHL`
    } else if (yrcRegex.test(trackingId)) {
        return `https://my.yrc.com/tools/track/shipments?referenceNumber=${trackingId}&referenceNumberType=PRO`
    } else {
        return '#'
    }
}
